<div class="branch-selector-container">
  <div class="branch-selector-title">
    <h6 class="mb-0">{{ "BRANCH_SELECTOR.TITLE" | translate }}</h6>
  </div>

  <div class="branch-card" (click)="toggleMenu()">
    <div class="branch-card-content">
      <div class="branch-card-primary">
        <div class="branch-icon-container">
          <img class="branch-icon" src="./assets/img/isotipo.svg" alt="" />
        </div>

        <div class="branch-info">
          <span class="branch-name">{{ branch.name }}</span>

          <span class="branch-locality">{{ branch.address?.city }}</span>
        </div>

        <div class="branch-actions">
          <mat-icon
            class="dropdown-icon"
            [class.rotated]="isMenuOpen"
            svgIcon="keyboard_arrow_down"
          ></mat-icon>
        </div>
      </div>

      <div class="branch-card-details">
        <div class="branch-address">
          <mat-icon class="branch-meta-icon" svgIcon="location_on"></mat-icon>

          <span class="branch-meta-text">{{ getFullAddress(branch) }}</span>
        </div>

        <div class="branch-schedule" *ngIf="scheduleLines.length">
          <mat-icon class="branch-meta-icon" svgIcon="access_time"></mat-icon>

          <span class="branch-meta-text">
            <ng-container *ngFor="let line of scheduleLines; let last = last">
              <span class="branch-schedule-label">{{
                getScheduleLineLabel(line)
              }}</span>

              {{ " " }}{{ getScheduleHours(line) }}

              <br *ngIf="!last" />
            </ng-container>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div
    class="branch-menu"
    *ngIf="isMenuOpen"
    (click)="$event.stopPropagation()"
  >
    <div class="branch-menu-content">
      <div *ngFor="let group of groupedBranches" class="branch-group">
        <div
          *ngFor="let branchItem of group.branches"
          class="branch-menu-item"
          [class.selected]="isSelected(branchItem)"
          (click)="selectBranch(branchItem)"
        >
          <span class="branch-menu-item-text"
            >{{ branchItem.name }} - {{ branchItem.address.city }}</span
          >
        </div>
      </div>
    </div>
  </div>

  <div
    class="branch-menu-overlay"
    *ngIf="isMenuOpen"
    (click)="closeMenu()"
  ></div>
</div>
